import { Expose } from "class-transformer";

export class CreateConsumableHasExternalReferenceDto {
  @Expose()
  consumableId: string;

  @Expose()
  supplierId: string;

  @Expose()
  externalReference: string;
}
